import React from 'react'

export const EcosistemasCards = ({ecosistema}) => {
  return (
    <section className='cob__cards-in'>
        <div className="coberturas__cards-in">
            {/* VERSION DESKTOP */}
            <div className="cob__card d-none d-lg-flex">
                <div>
                    <div className='cob__card-img'>
                        <img className='cob__card-icoprincipal' src={ecosistema.img} alt="imagen cob" />
                        <div className='cob__card-ico_container ' >
                            <img className={`cob__card-ico`} src={ecosistema.ico} alt="imagen cob icono" />
                        </div>
                    </div>
                    <div className="cob__card-texto">
                        <div className="cob__card-superior">
                            <h4 style={{ textAlign: 'center', marginBottom: '1em', marginTop: '1em'  }} className={`cob__card-title`}>{ecosistema.tituloEcosistema}</h4>
                            <p style={{ textAlign: 'center', fontSize: '1.5rem', lineHeight: '20px' }} className='cob__card-descripcion'>{ecosistema.descripcion}</p>
                        </div>
                    </div>
                </div>
            </div>

            {/* VERSION MOBILE */}
            <div className="cob__card d-flex d-lg-none">
                <div>
                    <div className='cob__card-img'>
                        <img className='cob__card-icoprincipal' src={ecosistema.img} alt="imagen cob" />
                        <div className='cob__card-ico_container ' >
                            <img className={`cob__card-ico`} src={ecosistema.ico} alt="imagen cob icono" />
                        </div>
                    </div>
                    <div className="cob__card-texto">
                        <div className="cob__card-superior">
                            <h4 style={{ textAlign: 'center', marginBottom: '1em', marginTop: '1em'  }} className={`cob__card-title`}>{ecosistema.tituloEcosistema}</h4>
                            <p style={{ textAlign: 'center', lineHeight: '20px' }} className='cob__card-descripcion cober__descripcion'>{ecosistema.descripcion}</p>  
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}
